import React from 'react'
import { useForm, ValidationError } from '@formspree/react';
import { CircularProgress } from '@mui/material';

const Contact = () => {

    const [state, handleSubmit] = useForm("xrgvyyvj");
    // if (state.succeeded) {
    //     return <p>Thanks for joining!</p>;
    // }

    return (
        <section className="contact section" id="contact"
            style={{ marginBottom: 35 }}
        >
            <h2 className="section__title">Contact Me</h2>
            <span className="section__subtitle">Get in touch</span>

            <div className="contact__container container grid">
                <div>
                    <div className="contact__information">
                        <i className="uil uil-phone contact__icon"></i>

                        <div>
                            <h3 className="contact__title">Call Me</h3>
                            <a className="contact__subtitle" href='+261 34 95 127 77'>+261 34 95 127 77</a>
                        </div>
                    </div>

                    <div className="contact__information">
                        <i className="uil uil-envelope contact__icon"></i>

                        <div>
                            <h3 className="contact__title">Email Me</h3>
                            <span className="contact__subtitle">andrianiainarolland123@gmail.com</span>
                        </div>
                    </div>

                    <div className="contact__information">
                        <i className="uil uil-map-marker contact__icon"></i>

                        <div>
                            <h3 className="contact__title">Location</h3>
                            <span className="contact__subtitle">Tsiadana Ambohidempona #VA 38 EH</span>
                        </div>
                    </div>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className="contact__form grid">
                    <div className="contact__inputs grid">
                        {/* <div className="contact__content">
                            <label htmlFor="name" className="contact__label">Name</label>
                            <input type="text" id="name" className="contact__input" />
                            <ValidationError
                                prefix="Name"
                                field="name"
                                errors={state.errors}
                            />
                        </div> */}
                        <div className="contact__content">
                            <label htmlFor="email" className="contact__label">Email</label>
                            <input id="email" type="email" name="email" className="contact__input" required />
                            <ValidationError
                                prefix="Email"
                                field="email"
                                errors={state.errors}
                            />
                        </div>
                    </div>
                    {/* <div className="contact__content">
                        <label htmlFor="subject" className="contact__label">Project</label>
                        <input type="text" id="subject" name="subject" className="contact__input" />
                    </div> */}
                    <div className="contact__content">
                        <label htmlFor="message" className="contact__label">Message</label>
                        <textarea name="message" id="message" cols={0} rows={7} className="contact__input" required></textarea>
                        <ValidationError
                            prefix="Message"
                            field="message"
                            errors={state.errors}
                        />
                    </div>

                    <div>
                        {!state.succeeded &&
                            <button type="submit" disabled={state.submitting} className="button button--flex"
                                style={{ border: 'none' }}
                            >
                                
                                {
                                    !state.submitting &&
                                    <>Send Message <i className="uil uil-message button__icon"></i></>
                                }
                                {
                                    state.submitting &&
                                    <>Sending Message<CircularProgress className="button__icon" size={22} sx={{ color:'white' }}/></>
                                }
                            </button>
                        }
                        {
                            state.succeeded &&
                            <p color='green'>Thanks for joining!</p>
                        }
                    </div>
                </form>
            </div>
        </section>

    )
}

export default Contact